
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"fill":"#D0EFEC","d":"M19.333 31.857h8.334c0-3.696 8.333-6.16 8.333-14.143C36 10.75 30.063 7 24.125 7 18.344 7 13.292 10.107 11 15.625l7.188 4.232c1.041-2.518 2.76-4.5 5.625-4.5 2.656 0 3.854 1.232 3.854 3.107 0 4.715-8.334 7.125-8.334 13.393M23.5 46c2.708 0 4.948-2.304 4.948-5.09s-2.24-5.089-4.948-5.089-4.948 2.304-4.948 5.09S20.792 46 23.5 46"}}),_c('path',{staticClass:"i-?",attrs:{"stroke":"#234652","d":"M20.833 29.857v.5h9.334v-.5c0-.73.412-1.458 1.175-2.314.473-.53 1.029-1.056 1.636-1.632.385-.363.79-.747 1.208-1.164 2.113-2.105 4.314-4.839 4.314-9.033 0-3.64-1.558-6.458-3.896-8.357-2.327-1.89-5.411-2.857-8.479-2.857-5.97 0-11.213 3.217-13.587 8.933l-.167.402.375.22 7.188 4.233.496.292.22-.532c1.009-2.44 2.597-4.19 5.163-4.19 1.258 0 2.088.292 2.597.729.497.427.757 1.05.757 1.877 0 1.02-.449 1.948-1.194 2.89-.646.815-1.477 1.598-2.368 2.438l-.449.423c-2.07 1.963-4.323 4.269-4.323 7.642ZM25.5 44.5c2.998 0 5.448-2.54 5.448-5.59 0-3.048-2.45-5.589-5.448-5.589s-5.448 2.541-5.448 5.59S22.502 44.5 25.5 44.5Z"}})])
          )
        }
      }
    